import {hasValue} from '@famly/stat_ts-utils_has-value';
import {useTransformQuery} from 'web-app/react/hooks/use-transform-query';

import type {
    InvoiceSummaryQueryVariables,
    InvoiceSummaryQuery,
} from '../queries/__generated__/invoice-summary.query.api-types';
import {InvoiceSummary as InvoiceSummaryGQL} from '../queries/invoice-summary.query';
import {
    type PlanUpdate,
    type InvoiceSummary,
    transformPlanUpdateToApi,
    transformInvoiceSummaryFromApi,
} from '../helpers/invoice-summary';

export const useInvoiceSummary = (
    siteId: string,
    childId: string,
    updatedPlan: PlanUpdate | undefined,
): {invoiceSummary: InvoiceSummary | null; isLoading: boolean} => {
    const [invoiceSummary, {loading}] = useTransformQuery<InvoiceSummaryQuery, InvoiceSummaryQueryVariables>()(
        InvoiceSummaryGQL,
        {
            variables: {
                siteId,
                childId,
                updatedPlan: hasValue(updatedPlan) ? transformPlanUpdateToApi(updatedPlan) : undefined,
            },
            fetchPolicy: 'cache-and-network',
        },
        ({data}) => {
            const periods = data?.finance.invoiceSummary.v1.overview.periods;
            if (!hasValue(periods)) {
                return null;
            }
            return transformInvoiceSummaryFromApi(periods);
        },
    );
    return {invoiceSummary, isLoading: loading};
};
